export default function PHP_protected() {
  return (
    <div>
      <h1>PHP_protected</h1>
    </div>
  );
}
